import config from 'config';
import * as Sentry from '@sentry/react';
import FallbackErrorComponent from './FallbackErrorComponent';

const initSentry = async (dsn) => {
  if (!dsn) {
    console.warn('[Sentry] No key available loaded'); // eslint-disable-line no-console
    return;
  }

  const release = config.APP_VERSION;
  const environment = config.ENVIRONMENT;

  Sentry.init({ dsn, release, environment });
};

const setUserContext = async (context) => {
  if (!context) {
    return;
  }

  Sentry.configureScope((scope) => {
    scope.setUser(context);
  });
};

const captureException = async (error) => {
  if (!error) {
    return;
  }
  Sentry.captureException(error);
};

const captureMessage = async (message, params) => {
  Sentry.captureMessage(message, params);
};

const ErrorBoundary = Sentry.ErrorBoundary;

export {
  ErrorBoundary,
  captureMessage,
  captureException,
  setUserContext,
  initSentry,
  FallbackErrorComponent,
};
